import gql from "graphql-tag";

export const ASSIGN_BILLING_ACCOUNT = gql`
  mutation assignBillingAccount($input: billingAccountInput) {
    assignBillingAccount(input: $input) {
      stripe
    }
  }
`;
